<div class="app-navbar-toggle" (click)="toggle()">
  <div class="i i--lg i-bars"></div>
</div>
